<template>
  <LLearnContainer>
    <div class="l-learn-audio">
      <lLearnCircle />
      <div class="audio-player">
        <!-- 唱片 -->
        <img class="l-learn-audio-record" :class="{ rotate: currentSong.playing }" src="./images/record.png" alt />
        <img class="l-learn-audio-handle" :class="{ 'handle-play': currentSong.playing }" src="./images/handle.png" alt />
        <div class="l-learn-audio-play">
          <div class="l-learn-audio-bottom">
            <!-- 进度 -->
            <div class="l-progress">
              <!-- 进度条 -->
              <div ref="progressSection" class="l-progress-section">
                <div id="l-progress-audio" class="l-progress-box" draggable="false" onselectstart="return false;"
                  oncontextmenu="return false;" ref="progressBox">
                  <div :style="{ width: `${audio.percent}%` }" ref="LProgress" class="l-progress-small">
                    <span :class="{ cursor: false }" class="circle"></span>
                  </div>
                </div>
              </div>
              <!-- 时间 -->
              <div class="l-time">
                <label class="l-time-show l-current-time">{{ audio.currentTime }}</label>
                <label class="l-time-show">{{ audio.totalTime }}</label>
              </div>
            </div>
            <!-- 播放按钮 -->
            <div class="l-audio-contrl" @click="togglePlayStatus">
              <span :class="{ 'l-pause': currentSong.playing}" class="l-play"></span>
            </div>
            <!-- <span v-if="currentSong.audioUrl" class="l-pause-number">剩余暂停次数：{{ currentSong.onceStopNum }}次</span> -->
          </div>
        </div>
      </div>
    </div>
    <PlayerList
      class="player-list"
      :week-list="weekList"
      @play="handlePlay" />
  </LLearnContainer>
</template>

<script>
import laudio from '@/utils/laudio'
import UPModel from '@/models/imgup'
import Study2Model from '@/models/study2'
import LLearnContainer from '@/components/l-learn-container/index.vue'
import lLearnCircle from '@/views/learn-new/components/l-learn-circle'
import PlayerList from './components/PlayerList.vue'

const imgUp = new UPModel()
const study = new Study2Model()


export default {
  name: 'l-xinfa',
  props: {
    autoplay: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    LLearnContainer,
    lLearnCircle,
    PlayerList,
  },
  data() {
    return {
      stage: 101,
      weekList: [],
      currentSong: {},
      laudio: null,
      audio: {
        target: null,
        play: false,
        totalTime: '',
        currentTime: '00:00:00',
        percent: 0,
        src: '',
        status: '',
        duration: 0,
      },
      currentIndex: 0,
      currentAudios: [],
    }
  },
  methods: {
    async getPlayList(stage) {
      const res = await study.getLessonAudios(stage)
      this.weekList = res.data.map(item => ({
          ...item,
          audios: item.audios.map(audio => ({
              ...audio,
              playing: false,
          })),
          isExpanded: false,
      })) || []
    },
    async getSongUrl(audio) {
      this.$lLoading.show()
      try {
        const res = await imgUp.getAudioUrl([audio.audioUrl])
        this.$lLoading.hide()
        audio.src = res.data[0].url
        this.audio.src = res.data[0].url
      } catch (err) {
        this.$lLoading.hide()
        console.log(err.msg)
      }
    },
    async handlePlay(data) {
      const { index, audios } = data
      const audio = audios[index]
      audio.playing = !audio.playing
      this.currentAudios = audios
      this.currentIndex = index
      if (this.currentSong.audioUrl && (this.currentSong.audioUrl !== audio.audioUrl)) {
          this.currentSong.playing = false
          this.recordPlayData(this.currentSong.id, this.laudio.currentTime)
      }
      this.currentSong = audio
      if (!audio.playing) {
        this.laudio.pause()
      } else {
        // if (!audio.src) {
        //   await this.getSongUrl(audio)
        // }
        if (!this.laudio) {
          await this._initAudio(audio.audioUrl)
        }
        if (this.laudio.src !== audio.audioUrl) {
          this.laudio.src = audio.audioUrl
        }
        setTimeout(() => {
          this.laudio.play()
        }, 500)
      }
    },
    async _initAudio(src) {
      this.laudio = laudio({
        autoplay: this.autoplay,
        src,
      })
      this.laudio.addEventListener('loadedmetadata', () => {
        this.audio.totalTime = this._format(this.laudio.duration)
        this.audio.duration = this.laudio.duration
      })
      this.laudio.addEventListener('ended', () => {
        this.recordPlayData(this.currentSong.id, this.laudio.currentTime)
        this.currentSong.playing = false
        this.playNextSong()
      })
      this.laudio.addEventListener('timeupdate', () => {
        this.audio.currentTime = this._format(this.laudio.currentTime)
        this.audio.percent = (this.laudio.currentTime / this.laudio.duration) * 100
      })
    },
    togglePlayStatus() {
      if (this.currentSong.playing) {
        this.laudio.pause()
      } else {
        this.laudio.play()
      }
      this.currentSong.playing = !this.currentSong.playing
    },
    playNextSong() {
      if (this.currentIndex === this.currentAudios.length - 1) {
        return
      }
      this.handlePlay({
        index: this.currentIndex + 1,
        audios: this.currentAudios,
      })
    },

    async recordPlayData(id, offset) {
      try {
        await study.recordPlayData({
          bizId: id,
          offset,
          command: 'PAUSE',
        })
      } catch (err) {
        console.log('记录播放数据失败：', err)
      }
    },
    
    // 格式时间
    _format(timezone) {
      // 取整，防止计算大浮点数
      timezone = parseInt(timezone)
      let time = []
      time[0] = parseInt(timezone / 60 / 60)
      time[1] = parseInt((timezone - time[0] * 60 * 60) / 60)
      time[2] = parseInt((timezone - time[0] * 60 * 60) % 60)

      time = time.map((item) => {
        return this._padStart(item)
      })
      return time.join(':')
    },
    _padStart(number) {
      return number < 10 ? `0${number}` : number
    },
  },
  created() {
    this.stage = Number(this.$route.query.stage)
    this.getPlayList(this.stage)
  },
  destroyed() {
    this.laudio ? this.laudio.pause() : null
    if (this.currentSong.audioUrl) {
      this.recordPlayData(this.currentSong.id, this.laudio.currentTime)
    }
  },
}
</script>

<style lang="stylus" scoped>
@import './index.styl'

.audio-player{
  width: 100%;
  height: 100%;
  position: absolute;
  left: -160px;
}

.player-list {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 20;
  right: 0;
}
</style>
